module.exports = __webpack_public_path__ + "static/img/second.f4263710.png";